/** Evento global para abrir el panel de sugerencias sin salir de la página actual. */
export const ACCOUNT_SUGGESTIONS_PANEL_EVENT = 'smart:open-account-suggestions-panel';

/** Evento global cuando el inventario de sugerencias pendientes cambia (aceptar, rechazar, generar). */
export const ACCOUNT_SUGGESTIONS_CHANGED_EVENT = 'smart:account-suggestions-changed';

export function notifyAccountSuggestionsChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ACCOUNT_SUGGESTIONS_CHANGED_EVENT));
}

export function subscribeAccountSuggestionsChanged(handler) {
  if (typeof window === 'undefined' || typeof handler !== 'function') return () => {};
  window.addEventListener(ACCOUNT_SUGGESTIONS_CHANGED_EVENT, handler);
  return () => window.removeEventListener(ACCOUNT_SUGGESTIONS_CHANGED_EVENT, handler);
}

/**
 * @param {{ direction?: boolean | null }} options
 *   direction: true = proveedores, false = clientes, null/undefined = ambos
 */
export function openAccountSuggestionsPanel(options = {}) {
  if (typeof window === 'undefined') return;
  const { direction = null } = options;
  window.dispatchEvent(
    new CustomEvent(ACCOUNT_SUGGESTIONS_PANEL_EVENT, {
      detail: { direction },
    }),
  );
}

/** Parsea `sugerencias-cuentas?dir=providers|clients` desde hash o URL. */
export function parseSuggestionsDirectionFromUrl(urlOrHash) {
  const raw = String(urlOrHash || '');
  const query = raw.includes('?') ? raw.slice(raw.indexOf('?') + 1) : '';
  const params = new URLSearchParams(query);
  const dir = params.get('dir');
  if (dir === 'providers') return true;
  if (dir === 'clients') return false;
  return null;
}

export function isAccountSuggestionsRedirectUrl(url) {
  if (!url || typeof url !== 'string') return false;
  return url.includes('sugerencias-cuentas');
}
